/**
 * Monthly and yearly variants of the same tier share a name, except for the " Annual" suffix.
 */
export const getBaseProductName = (productName?: string | null): string | undefined => {
  return productName?.trim().replace(/\s+Annual$/i, "");
};
